'use client';

import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FilterSystem = ({
  industries,
  services,
  outcomes,
  selectedIndustries,
  selectedServices,
  selectedOutcomes,
  onIndustryToggle,
  onServiceToggle,
  onOutcomeToggle,
  onClearAll,
  className = '',
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const totalFilters =
    selectedIndustries.length +
    selectedServices.length +
    selectedOutcomes.length;

  return (
    <div className={`bg-white border border-border rounded-lg shadow-subtle ${className}`}>
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-4 md:p-6 transition-colors duration-300"
      >
        <div className="flex items-center space-x-3">
          <Icon name="FunnelIcon" size={24} className="text-red-600" />
          <span className="text-lg font-headline font-bold text-foreground">
            Filter Results
          </span>

          {totalFilters > 0 && (
            <span className="shadow-subtle text-red-600-foreground text-xs sm:text-lg font-bold px-2 py-1 rounded-xl">
              {totalFilters}
            </span>
          )}
        </div>

        <Icon
          name={isExpanded ? 'ChevronUpIcon' : 'ChevronDownIcon'}
          size={32}
          className="text-muted-foreground shadow-subtle rounded-full"
        />
      </button>

      {isExpanded && (
        <div className="p-4 md:p-6 border-t border-border space-y-3">
          <div className="flex justify-between items-center">
            <h3 className="text-sm font-headline font-bold text-foreground">
              Active Filters
            </h3>

            {totalFilters > 0 && (
              <button
                onClick={onClearAll}
                className="text-sm text-red-600 hover:text-accent font-semibold transition-colors duration-300"
              >
                Clear All
              </button>
            )}
          </div>

          <div className="space-y-3">
            {/* Services */}
            <div>
              <h4 className="text-sm font-headline font-semibold text-foreground mb-3">
                Service Type
              </h4>

              <div className="flex flex-wrap gap-2">
                {services.map((service) => (
                  <button
                    key={service.id}
                    onClick={() => onServiceToggle(service.id)}
                    className={`px-4 py-1 rounded-lg text-sm font-semibold transition-all duration-300 shadow-subtle border border-red-600/20 ${
                      selectedServices.includes(service.id)
                        ? 'bg-red-600/20  text-red-600-foreground shadow-cta'
                        : 'bg-muted text-foreground hover:bg-border'
                    }`}
                  >
                    {service.label} ({service.count})
                  </button>
                ))}
              </div>
            </div>

            {/* Industry */}
            <div>
              <h4 className="text-sm font-headline font-semibold text-foreground mb-3">
                Industry
              </h4>

              <div className="flex flex-wrap gap-2">
                {industries.map((industry) => (
                  <button
                    key={industry.id}
                    onClick={() => onIndustryToggle(industry.id)}
                    className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-300 shadow-subtle border border-red-600/20 ${
                      selectedIndustries.includes(industry.id)
                        ? 'bg-red-600/20 shadow-subtle text-red-600-foreground shadow-cta'
                        : 'bg-muted text-foreground hover:bg-border'
                    }`}
                  >
                    {industry.label} ({industry.count})
                  </button>
                ))}
              </div>
            </div>

            {/* Outcomes */}
            <div>
              <h4 className="text-sm font-headline font-semibold text-foreground mb-3">
                Measurable Outcomes
              </h4>

              <div className="flex flex-wrap gap-2">
                {outcomes.map((outcome) => (
                  <button
                    key={outcome.id}
                    onClick={() => onOutcomeToggle(outcome.id)}
                    className={`px-4 py-1 rounded-lg text-sm font-semibold transition-all duration-300 shadow-subtle border border-red-600/20 ${
                      selectedOutcomes.includes(outcome.id)
                        ? 'bg-red-600/20 text-red-600-foreground shadow-cta'
                        : 'bg-muted text-foreground hover:bg-border'
                    }`}
                  >
                    {outcome.label} ({outcome.count})
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterSystem;
